import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

import { AtividadeMensagensService } from './atividade-mensagens.component.service';
import { AtividadeMensagens } from '../models/atividade-mensagens';
import { UserService } from '@/core/service/user.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'max-atividade-mensagens',
    templateUrl: './atividade-mensagens.component.html',
    styleUrls: ['atividade-mensagens.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TableModule,
        TextareaModule,
        ButtonModule,
        ToastModule
    ],
    providers: [MessageService]
})
export class AtividadeMensagensComponent implements OnInit {
  atividadeMensagens: AtividadeMensagens[] = [];
  @Input() idAtividade: number = 0;
  loading: boolean = false;
  value: null | string = '';
  idUser: number = 0;

  constructor(
    private atividadeMensagensService: AtividadeMensagensService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.idUser = this.userService.getUserId();
    this.loading = true;
    this.getAtividadeMensagens();
  }

  getAtividadeMensagens() {
    this.atividadeMensagensService.getAtividadeMensagens(this.idAtividade).subscribe((atvMensagens) => {
      this.atividadeMensagens = atvMensagens;
      this.loading = false;
    });
  }

  onConfirm() {
    const body = {
      idUsuario: Number(this.idUser),
      mensagem: this.value,
    };

    this.atividadeMensagensService.insertAtividadeMensagens(this.idAtividade, body).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Mensagem inserida com sucesso!',
        });
        this.getAtividadeMensagens();
        this.value = null;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao inserir Mensagem.',
        });

        // Erro na requisição
      },
    });
  }
}
